<template>
    <div class="box">
        <div class="box2">
            <div class="complaintInformation">
                <div class="complaintOder border_bottom">
                    <div class="left">投诉分类</div>
                    <div class="right">
                        <span>请选择 ></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less" scoped>

</style>
